import { jsx } from "react/jsx-runtime";
import MuiButton from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
function Button({
  size = "large",
  variant = "Primary",
  loading = false,
  loadingText = "Loading...",
  startIcon,
  children,
  maxWidth,
  sx,
  ...props
}) {
  const variantToColor = {
    Primary: "primary",
    Secondary: "primary",
    Tertiary: "primary",
    Error: "error",
    ErrorSecondary: "error",
    ErrorTertiary: "error",
    Warning: "warning",
    WarningSecondary: "warning",
    WarningTertiary: "warning"
  };
  const variantLookup = {
    Primary: "contained",
    Secondary: "outlined",
    Tertiary: "text",
    Error: "contained",
    ErrorSecondary: "outlined",
    ErrorTertiary: "text",
    Warning: "contained",
    WarningSecondary: "outlined",
    WarningTertiary: "text"
  };
  return /* @__PURE__ */ jsx(MuiButton, { size, color: variantToColor[variant] || variantToColor.Primary, variant: variantLookup[variant] || variantLookup.Tertiary, startIcon: loading && startIcon ? /* @__PURE__ */ jsx(CircularProgress, { sx: {
    mt: size === "small" ? "2px" : 0
  }, size: size === "small" ? 14 : 20, color: "inherit" }) : startIcon, disabled: loading ? true : props.disabled, disableRipple: true, disableFocusRipple: true, ...props, sx: {
    maxWidth,
    ...sx
  }, children: loading ? loadingText : children });
}
export {
  Button
};
//# sourceMappingURL=index.js.map
